import basicLinkedList from "../../../../src/posts/tech/linked-lists-and-their-uses/basic-linked-list.png";
import linkedListInsertion from "../../../../src/posts/tech/linked-lists-and-their-uses/linked-list-insertion.png";
import linkedListDeletion from "../../../../src/posts/tech/linked-lists-and-their-uses/linked-list-deletion.png";
import boy from "../../../../src/posts/tech/linked-lists-and-their-uses/boy.png";
import * as React from 'react';
export default {
  basicLinkedList,
  linkedListInsertion,
  linkedListDeletion,
  boy,
  React
};